import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ColDef, ExcelExportParams, GridReadyEvent, ISetFilterParams, themeQuartz, ValueFormatterParams } from 'ag-grid-community';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import * as saveAs from 'file-saver';
import { Config } from 'src/app/app-constant';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { SharedService } from 'src/app/service/shared/shared.service';

import { NativeDateAdapter } from '@angular/material/core';
import * as XLSX from 'xlsx';
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { DateAdapter } from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { calculateFiscalYear, formatText, formatYearRanges } from 'src/app/shared/commen-function-file';
import { formatDate } from 'src/app/shared/commen-function-file';
import * as moment from 'moment';
import { CommentDialogComponent } from 'src/app/shared/comment-dialog/comment-dialog.component';


export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
}

@Component({
  selector: 'app-expense-report',
  templateUrl: './expense-report.component.html',
  styleUrls: ['./expense-report.component.scss'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' }, // Use en-GB to get DD/MM/YYYY format
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
  ],
})
export class ExpenseReportComponent implements OnInit {
  allTeamReimbursement: any = [];
  allTeamMemberReimbursementApprove: any = [];
  currentallTeamMemberReimbursementApprove: any = [];
  allListingEmployeeId: any = [];
  allListingEmployeeIdForTeam: any = [];
  currrentTableDataDetails: any = [];
  fitergetAllFinanceUserDDHrAdmin: any = []
  tableDataDetails: any = [];
  selectedEmployeeIdForReport: any;
  dropdownData: any;
  loggedInUserCompanyID: any;
  loggedInCompanyFiscalyear: any | null;
  loggedInUserId: any | null;
  year: any;
  fiscalYear: any;
  buttonColorName: any | null;
  loggedInUserName: any | null;
  loggedInCompanyMDCode: any | null;
  loggedInUserRole: any | null;
  loggedInUserRoles: any;
  loggedInCompanyReviewCycle: any | null;
  loggedInUserRoleIsEmployee: boolean = false;
  approveMatrixValueForCondition: any;
  financePerson: any;
  fromYear: any;
  toYear: any;
  selectedTypeTabIndex = 0;
  selectedTypeTabName = 'Employee'
  isFinanceLoginUser: boolean = false;
  showSetupPopup: boolean = false;
  showImportPopup: boolean = false;

  selectedManagerDashboardId: boolean = false;
  isShowSelectEmployee: boolean = false;
  selectedEmployeeDashboardId: any;

  // Default selected page size
  selectedPageSize: number = 25;
  loggedInUserCompanyName: any;
  currentTableDataDetailsForEmployee: any = [];
  EmployeeSummaryData: any = [];
  arrEmployeeDetiailsBandLocation: any = [];
  arrExpensTypeData: any = [];
  arrLocationForReimursement: any = [];
  arrBandsForReimursement: any = [];
  defaultFromDate: any;
  defaultToDate: any;

  selectedOptionReportOne: string = 'fiscal';

  dateRangeOptions = [
    { label: 'Fiscal Year', value: 'fiscal' }
  ];

  taskColumnHeaderInfo: any[] = [];
  taskColumnHeaderInfoForManager: any[] = [];
  taskColumnHeaderInfoForFinanse: any = [];
  loggedInHODManager: any;

  constructor(public sharedService: SharedService,
    private encryptionService: EncryptionService, private activatedroute: ActivatedRoute,
    private httpService: HttpService, private config: Config, public router: Router,
    public dialog: MatDialog, private datePipe: DatePipe,
  ) { }

  ngOnInit() {
    this.loggedInHODManager = sessionStorage.getItem('HODManager');
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.financePerson = sessionStorage.getItem('financeAdminId');
    this.financePerson = sessionStorage.getItem('financeAdminId');

    if (this.financePerson != 0 && this.financePerson && this.financePerson !== 'undefined' && this.financePerson.trim() !== '') {
      this.isFinanceLoginUser = true;
    } else {
      //Not a valid finance person
      this.isFinanceLoginUser = false;
    }

    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    this.loggedInUserCompanyName = sessionStorage.getItem('loggedInUserCompanyName');

    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    this.loggedInUserName = sessionStorage.getItem('loggedInUserName');
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    this.loggedInCompanyMDCode = sessionStorage.getItem('loggedInCompanyMDCode');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    this.loggedInUserRoles = JSON.parse(sessionStorage.getItem('loggedInUserRoles') || '[]');
    this.loggedInCompanyReviewCycle = sessionStorage.getItem('loggedInCompanyReviewCycle') || null;


    if (this.loggedInUserRoles.length == 1) {
      for (let i = 0; i < this.loggedInUserRoles?.length; i++) {
        if (this.loggedInUserRoles[i].displayName == "Employee") {
          this.loggedInUserRoleIsEmployee = true
        }
      }
    }

    this.approveMatrixValueForCondition = this.httpService.passApprovematrixForReport;
    console.log(this.approveMatrixValueForCondition);

    this.getAllUserDD();
    this.getpmsyearlist();

    this.empReimbursementTable();

    // Initialize the paged data

    this.getEmployee();
    this.getEmployeeDetiailsBandLocation();


    let today = new Date();
    // Set the taskFromDate to 15 days before today's date
    let taskFromDate = new Date(today);
    taskFromDate.setDate(today.getDate() - 12);
    this.defaultFromDate = taskFromDate.toISOString().split('T')[0];

    // Set the taskToDate to today's date
    let taskToDate = new Date(today);
    taskToDate.setDate(today.getDate() + 2);
    this.defaultToDate = taskToDate.toISOString().split('T')[0];

    this.taskFromDate = this.defaultFromDate;
    this.taskToDate = this.defaultToDate;

    this.onDateChangeDashboard(this.defaultFromDate, this.defaultToDate);

  }

  // --------------------------------AG GRID CODE---------------------------------------------------------
  gridApi: any;
  paginationPageSizeSelector = [5, 10, 20, 50, 100, 200, 500, 1000];
  pagination = true;
  paginationPageSize = 10;
  detailRowAutoHeight = true;

  defaultColDef: ColDef = {
    flex: 1,
    minWidth: 100,
    filter: true,
    resizable: true,
    sortable: true,
    floatingFilter: false,  // ✅ small filter box under header
  };

  gridOptions: any = {
    defaultColDef: {
      resizable: true,
      sortable: true,
      filter: true,
      floatingFilter: true,
      minWidth: 80,

      // ✅ add this
      cellClass: (p: any) => (p.node.rowIndex % 2 === 0 ? 'cell-even' : 'cell-odd')
    },
    context: { componentParent: this },
    rowSelection: 'single',
    localeText: {
      noRowsToShow: 'No Data Found'  // default text ko replace karna hai 'No Rows To Show' to 'No Data Found'
    }
  };

  openCommentModal(text: string, commentType: any) {
    this.dialog.open(CommentDialogComponent, {
      width: '600px',
      data: {
        text: text,
        commentType: commentType
      }
    });

  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    params.api.sizeColumnsToFit();
    console.log(params)
  }
  formatStatus(value: any): string {
    if (!value || typeof value !== 'string') {
      return 'N/A'; // fallback agar value string na ho
    }

    // Camel Case → Title Case
    return value
      .toLowerCase()
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  formatDate(value: any): string {
    if (!value) return 'N/A';

    const date = new Date(value);
    if (isNaN(date.getTime())) return 'Invalid Date';

    // dd-MM-yyyy format
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  }


  // Helper function to convert any date string into dd-MM-yyyy
  formatDateOnly(dateStr: string | null): string | null {
    if (!dateStr) return null;

    let datePart = dateStr;
    if (dateStr.includes('T')) {
      datePart = dateStr.split('T')[0];
    }

    const [y, m, d] = datePart.split('-').map(Number);
    if (!y || !m || !d) return null;

    // Date object 
    const date = new Date(y, m - 1, d);

    // Format dd-MM-yyyy
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  }

  // ✅ Global search function
  onFilterTextBoxChanged(value: string = '') {
    if (!this.gridApi) return;

    // v31+ way:
    this.gridApi.setGridOption('quickFilterText', value ?? '');

  }

  onBtExport() {
    const params: ExcelExportParams = {
      fileName: 'Expense_Report_' + new Date().toISOString().slice(0, 10) + '.xlsx',
      sheetName: 'ExpenseData',
      exportAsExcelTable: {
        showRowStripes: true,
        name: 'ExpenseTable'
      },
      processCellCallback: (cell) => {
        const header = cell.column.getColDef().headerName;
        const value = cell.value;

        // 1. Date Formatting (for specific headers)
        const dateColumns = ['date', 'dateOfExpense']; // <- field names ya headerName use karo

        if (dateColumns.includes(cell.column.getColId()) && cell.value) {
          const date = new Date(cell.value);
          if (!isNaN(date.getTime())) {
            return (
              ('0' + date.getDate()).slice(-2) +
              '-' +
              ('0' + (date.getMonth() + 1)).slice(-2) +
              '-' +
              date.getFullYear()
            );
          }
        }

        // 2. Status Formatting (make it human readable)
        if (header === 'Status' && value) {
          return value
            .toString()
            .toLowerCase()
            .replace(/_/g, ' ') // replace underscores with space
            .replace(/\b\w/g, (char: any) => char.toUpperCase()); // capitalize each word
        }

        return value;
      }
    };

    this.gridApi.exportDataAsExcel(params);
  }

  approvalRenderer(params: any) {
    if (!params.value) return '';
    const status = params.value.toUpperCase();

    let color = '';
    if (status === 'APPROVED') {
      color = '#4caf50'; // green
    } else if (status === 'REJECTED') {
      color = '#f44336'; // red
    } else if (status === 'PENDING') {
      color = '#ff9800'; // orange
    }

    return `
          <span style="
            border: 1px solid ${color};
            color: ${color};
            padding: 4px 10px;
            border-radius: 12px;
            font-size: 12px;
            font-weight: 500;
            display: inline-block;
            line-height: 20px;
            white-space: nowrap;
          ">
        ${status.charAt(0) + status.slice(1).toLowerCase()}
      </span>
    `;
  }

  statusFormatter(params: any): string {
    if (!params.value) return '';

    const valueUpper = params.value.toUpperCase();

    // 🔹 Status → Color map
    const statusColors: Record<string, string> = {
      'APPROVED_BY_FINANCE_BUT_NOT_PAID': '#4caf50', // green
      'APPROVED_BY_MANAGER_SENT_TO_FINANCE': '#4caf50',
      'APPROVED_BY_MANAGER_REJECTED_BY_FINANCE': '#f44336', // red
      'REJECTED_BY_MANAGER': '#f44336',
      'PENDING_WITH_MANAGER': '#ff9800' // orange
    };

    // 🔹 Default color = grey
    const color =
      Object.keys(statusColors).find(key => valueUpper.includes(key))
        ? statusColors[
        Object.keys(statusColors).find(key => valueUpper.includes(key))!
        ]
        : '#999';

    // 🔹 Convert to Title Case
    const formattedText = params.value
      .toLowerCase()
      .split('_')
      .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');

    return `
      <span style="
        border: 1px solid ${color};
        color: ${color};
        padding: 4px 10px;
        border-radius: 12px;
        font-size: 12px;
        font-weight: 500;
        display: inline-block;
        white-space: normal;
        word-wrap: break-word;
        line-height: 1.4em;
        animation: fadeInScale 0.3s ease-in-out;
        max-width: 100%;
      ">
        ${formattedText}
      </span>
    `;
  }

  dateRenderer(params: any) {
    if (!params.value) return '';
    const date = new Date(params.value);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  dateComparator(valueA: string, valueB: string) {
    const parseDate = (value: string) => {
      if (!value) return null;
      // Agar backend se yyyy-mm-dd aa raha hai:
      if (value.includes('-') && value.indexOf('-') === 4) {
        return new Date(value).getTime();
      }
      // Agar already dd-mm-yyyy format hai:
      const [day, month, year] = value.split('-').map(Number);
      return new Date(year, month - 1, day).getTime();
    };

    const dateA = parseDate(valueA);
    const dateB = parseDate(valueB);

    if (dateA === dateB) return 0;
    if (dateA == null) return -1;
    if (dateB == null) return 1;
    return dateA - dateB;
  }

  openFile(fileUrl: string) {
    window.open(fileUrl, '_blank');
  }
  downloadRenderer = (params: any) => {

    const fileUrl = `${this.config.downloadFile}${params.value}`;
    if (!params.value) return '';
    const img = document.createElement('img');
    img.src = 'assets/icon/yellowdownload.png'; // replace with your icon path
    img.alt = 'download';
    img.style.width = '18px';
    img.style.height = '18px';
    img.style.cursor = 'pointer';
    img.title = params.value;
    img.addEventListener('click', (e) => {
      e.stopPropagation();
      // open file in new tab
      window.open(fileUrl, '_blank');
    });
    return img;
  }

  downloadDialogRenderer(fileName: string): string {
    if (!fileName) return '';
    return `${this.config.downloadFile}${fileName}`;
  }
  selectedRow: any;
  isDetailsOpen = false;
  onRowClicked(event: any) {
    this.selectedRow = event.data;
    this.isDetailsOpen = true;
  }
  closeDetails() {
    this.isDetailsOpen = false;
  }

  isClicked = false;


  resetGrid() {
    this.isClicked = false; // Trigger animation

    if (this.gridApi) {
      // ✅ Reset filters & sorting
      this.gridApi.setFilterModel(null);
      // this.gridApi.setSortModel(null);
      this.gridApi.deselectAll();

      // ✅ Reset quick filter (search box)
      this.searchTaskString = '';
      this.gridApi.setGridOption('quickFilterText', ''); // Clears quick filter text

      // ✅ Reset pagination
      this.paginationPageSize = 10;
      this.gridApi.setGridOption('paginationPageSize', this.paginationPageSize);
      this.gridApi.paginationGoToFirstPage();

      // ✅ Force refresh so UI input also clears
      this.gridApi.refreshCells();
      this.gridApi.resetColumnState();         // ✅ Reset columns
    }
  }
  // --------------------------------AG GRID CODE---------------------------------------------------------

  onChangeExpenseDate(option: string, graphType: any) {

    this.onRangeSelect(option, graphType);
  }

  onRangeSelect(option: string, graphType: any) {
    const today = moment();

    switch (option) {
      case 'today':
        this.taskFromDate = today.startOf('day').toDate();
        this.taskToDate = today.endOf('day').toDate();
        break;

      case 'yesterday':
        this.taskFromDate = today.subtract(1, 'day').startOf('day').toDate();
        this.taskToDate = moment().subtract(1, 'day').endOf('day').toDate();
        break;

      case 'last7':
        this.taskFromDate = moment().subtract(6, 'days').startOf('day').toDate();
        this.taskToDate = moment().endOf('day').toDate();
        break;

      case 'last30':
        this.taskFromDate = moment().subtract(29, 'days').startOf('day').toDate();
        this.taskToDate = moment().endOf('day').toDate();
        break;

      case 'thisMonth':
        this.taskFromDate = moment().startOf('month').toDate();
        this.taskToDate = moment().endOf('month').toDate();
        break;

      case 'lastMonth':
        this.taskFromDate = moment().subtract(1, 'month').startOf('month').toDate();
        this.taskToDate = moment().subtract(1, 'month').endOf('month').toDate();
        break;

      case 'fiscal':
        // You can make a year list like 2023-24, 2024-25 in another dropdown
        // For example, April to March fiscal year
        const fiscalStart = moment().month() < 3
          ? moment().subtract(1, 'year').month(3).startOf('month')
          : moment().month(3).startOf('month');

        const fiscalEnd = fiscalStart.clone().add(1, 'year').subtract(1, 'day');
        this.taskFromDate = fiscalStart.toDate();
        this.taskToDate = fiscalEnd.toDate();
        break;

      case 'custom':
        // Do nothing; user will pick manually
        this.taskFromDate = null;
        this.taskToDate = null;
        break;
    }
  }

  getEmployee() {

    const request = {
      "companyId": this.loggedInUserCompanyID,
      "userId": this.loggedInUserId
    };
    this.httpService.callPostService(this.config.getTeamOfManager, request).subscribe((data: any) => {
      this.EmployeeSummaryData = data.data;


    })
  }

  getEmployeeDetiailsBandLocation() {

    const request = {
      "companyId": this.loggedInUserCompanyID
    };
    this.httpService.callGetService(`${this.config.EmployeeDetiailsBandLocation}/${this.loggedInUserCompanyID}`).subscribe((result: any) => {
      this.arrEmployeeDetiailsBandLocation = result.data;
    })
  }


  formatedataVariable = formatText;

  tabTypeChanged(event: MatTabChangeEvent) {

    this.selectedTypeTabName = event.tab.textLabel;
    this.selectedTypeTabIndex = event?.index;
  }

  getAllFinanceUserDD: any = []
  getAllUserDD() {

    this.httpService.callGetService(`${this.config.getAllEmployee}/${this.loggedInUserCompanyID}`)
      .subscribe((result: any) => {

        this.getAllFinanceUserDD = result.data.users;

      });
  }
  fitergetAllFinanceUserDD: any = [];
  getAllEmployeeListing() {

    // this.getAllEmployeeListinga()
    this.httpService.callGetService(`${this.config.allReimbursementApplication}/${this.loggedInUserCompanyID}`)
      .subscribe((response: any) => {

        this.tableDataDetails = [];
        this.allTeamMemberReimbursementApprove = [];
        this.allTeamReimbursement = [];
        this.fitergetAllFinanceUserDD = [];

        const rawData = response.data;
        const arrReimbursementApplication = rawData.map((item: any) => ({
          ...item,
          date: this.formatDateOnly(item.date),             // ✅ always dd-MM-yyyy
          dateOfExpense: this.formatDateOnly(item.dateOfExpense) // ✅ always dd-MM-yyyy
        }));

        var tableDataDetails = arrReimbursementApplication.filter(
          (data: { year: any; }) => data?.year === this.selectedYearForCompetency
        );
        if (tableDataDetails.length == 0) {
          this.fitergetAllFinanceUserDD = [];
          this.arrBandsForReimursement = [];
          this.arrLocationForReimursement = [];
          this.arrExpensTypeData = [];
          this.allListingEmployeeIdForTeam = [];


          return;
        }

        const arrResultEmployeesData = this.arrEmployeeDetiailsBandLocation.filter((user: { id: any; }) => tableDataDetails.some((elm: { employeeId: { toString: () => any; }; }) => elm.employeeId.toString() === user.id));


        tableDataDetails.forEach((expense: any) => {
          const matchedUser = arrResultEmployeesData.find(
            (user: any) => +user.id === expense.employeeId
          );

          if (matchedUser) {
            expense['location'] = matchedUser.location;
            expense['band'] = matchedUser.band;

          }
        });

        tableDataDetails.map((elm: any) => {
          if (!this.arrBandsForReimursement.some((record: any) => record.band == elm.band)) {
            this.arrBandsForReimursement.push(elm);
          }

          if (!this.arrLocationForReimursement.some((record: any) => record.location == elm.location)) {
            this.arrLocationForReimursement.push(elm);
          }

        })

        this.arrBandsForReimursement = this.arrBandsForReimursement.filter((elm: any) => elm.band != null)
        this.arrLocationForReimursement = this.arrLocationForReimursement.filter((elm: any) => elm.band != null)



        if (tableDataDetails.length == 0) {
          return;
        }
        var allExpensData: { reimbursementid: any; reimbursementType: any; }[] = [];
        var arrEmployeesData: { employeeId: any; employeeName: any; }[] = [];
        const managerEmployeId = this.EmployeeSummaryData.map((elm: any) => elm.id);


        if ((this.loggedInUserRole == 'Manager' || this.loggedInHODManager == 'HODManager' || this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'MD') && sessionStorage.getItem('financeAdminId') == this.loggedInUserId) {
          // For Finance/Manager Login
          console.log("For Finance Login")
          // For Team Reimbursement Condition here --- finance

          // My Reimbursement -- current user login only show Reimbursement data (as employee)
          tableDataDetails.forEach((elm: any, i: any) => {

            if (this.loggedInUserId == elm.employeeId) {
              var arrEmployeeList = { "employeeId": elm.employeeId, "employeeName": elm.employeeName };

              // Check if employeeId already exists in the array (to avoid duplicates)
              let isDuplicateEmployee = this.allListingEmployeeId.some(
                (employee: { employeeId: any; }) => employee.employeeId === elm.employeeId
              );

              if (elm.approvedByManager === "APPROVED") {
                if (!isDuplicateEmployee) {
                  elm.financeStatus = elm.approvedStatus;
                  this.allListingEmployeeId.push(arrEmployeeList); //TODO : main problem
                }
              }
              // Avoid pushing duplicates into tableDataDetails
              let isDuplicateInTableData = this.tableDataDetails.some((existingElm: any) => existingElm.reimbursementApplicationId === elm.reimbursementApplicationId);

              if (!isDuplicateInTableData) {
                this.tableDataDetails.push(elm);
              }
              this.currentTableDataDetailsForEmployee = this.tableDataDetails;
            }
          });



          // For Team Reimbursement Condition here --- mnanager/finanace
          tableDataDetails.forEach((elm: any, i: any) => {

            if (elm.employeeId) {
              var arrEmployeeList = { "employeeId": elm.employeeId, "employeeName": elm.employeeName }

              // Check if employeeId already exists in the array
              let isDuplicate = this.allListingEmployeeIdForTeam.some(
                (employee: { employeeId: any; }) => employee.employeeId === elm.employeeId
              );

              if (!isDuplicate) {
                this.allListingEmployeeIdForTeam.push(arrEmployeeList);
                this.allListingEmployeeIdForTeam = this.allListingEmployeeIdForTeam.filter((record: any) => managerEmployeId.includes(record.employeeId));
              }

              if (elm.financeId == parseInt(this.loggedInUserId)) {
                let arrExpenseList = { "reimbursementid": elm.reimbursementid, "reimbursementType": elm.reimbursementType };
                allExpensData.push(arrExpenseList);
                this.arrExpensTypeData = this.removeDuplicateExpensIds(allExpensData);

              }

              // this.allTeamReimbursement.push(elm);
              // Check for duplicates before adding
              const isDuplicatelist = this.allTeamReimbursement.some(
                (item: any) => item.reimbursementApplicationId === elm.reimbursementApplicationId
              );

              if (!isDuplicatelist) {
                elm.managerStatus = elm.approvedByManager;

                this.allTeamReimbursement.push(elm);

                this.allTeamReimbursement = this.allTeamReimbursement.filter((record: any) => managerEmployeId.includes(record.employeeId));

              }
            }
          })
          // For Team Reimburesement
          this.currrentTableDataDetails = this.allTeamReimbursement;


          // For Reimbursement Approve tab
          tableDataDetails.forEach((elm: any) => {
            // Add unique employee to allListingEmployeeId
            const arrEmployeeList = { employeeId: elm.employeeId, employeeName: elm.employeeName };

            const isDuplicate = this.allListingEmployeeId.some(
              (employee: { employeeId: any }) => employee.employeeId === elm.employeeId
            );


            // Filter and update approved reimbursements
            if (this.approveMatrixValueForCondition == 'EMPLOYEE_TO_FINANCE') {
              if ((elm.financeId == null) || (elm.financeId == parseInt(this.loggedInUserId))) {
                if (!isDuplicate) {
                  this.allListingEmployeeId.push(arrEmployeeList); // TODO
                }
              }
            } else {
              if (elm.approvedByManager === "APPROVED" && ((elm.financeId == null) || (elm.financeId == parseInt(this.loggedInUserId)))) {
                if (!isDuplicate) {
                  this.allListingEmployeeId.push(arrEmployeeList); // TODO
                }
              }

            }

            //  NEW FLOW: EMPLOYEE → MANAGER → HR → FINANCE
            if (this.approveMatrixValueForCondition == 'EMPLOYEE_TO_MANAGER_TO_HR_TO_FINANCE') {
              this.allTeamMemberReimbursementApprove =
                this.allTeamMemberReimbursementApprove.filter((elm: any) =>
                  elm.approvedByManager === "APPROVED" &&
                  elm.approvedByHrAdmin === "APPROVED" &&
                  (
                    elm.financeId == null ||
                    elm.financeId == parseInt(this.loggedInUserId)
                  ) &&
                  elm.status !== "REJECTED_BY_MANAGER" &&
                  elm.status !== "REJECTED_BY_HR_ADMIN"
                );
            }

            elm.financeStatus = elm.approvedStatus; // status finance
            // console.log( elm.financeStatus);

            this.allTeamMemberReimbursementApprove.push(elm);



          });
          // Assign filtered approvals to currentallTeamMemberReimbursementApprove
          if (this.approveMatrixValueForCondition == 'EMPLOYEE_TO_FINANCE') {
            this.allTeamMemberReimbursementApprove = this.allTeamMemberReimbursementApprove.filter(
              (elm: any) => ((elm.financeId == null) || (elm.financeId == parseInt(this.loggedInUserId)))
            );
          } else {
            this.allTeamMemberReimbursementApprove = this.allTeamMemberReimbursementApprove.filter(
              (elm: any) => (elm.approvedByManager === "APPROVED" && ((elm.financeId == null) || (elm.financeId == parseInt(this.loggedInUserId))))
            );

          }
          // For Reimbursement Approve
          this.currentallTeamMemberReimbursementApprove = this.allTeamMemberReimbursementApprove;


        } else if ((this.loggedInUserRole == 'Manager' || this.loggedInHODManager == 'HODManager' || this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'MD') && sessionStorage.getItem('financeAdminId') != this.loggedInUserId) {
          // For Manager Login
          console.log("For Manager Login")
          tableDataDetails.forEach((elm: any, i: any) => {
            if (this.loggedInUserId == elm.employeeId) {
              var arrEmployeeList = { "employeeId": elm.employeeId, "employeeName": elm.employeeName };


              this.allListingEmployeeId.push(arrEmployeeList); // select employee

              // Avoid pushing duplicates into tableDataDetails
              let isDuplicateInTableData = this.tableDataDetails.some((existingElm: any) => existingElm.reimbursementApplicationId === elm.reimbursementApplicationId);

              if (!isDuplicateInTableData) {

                if (elm.approvedByManager == null) {
                  elm.financeStatus = elm.approvedStatus;
                  elm.approvedStatus = 'PENDING';
                } else {
                  elm.approvedStatus = (elm.approvedStatus == 'Reject') ? elm.approvedStatus : elm.approvedByManager;

                }

                this.tableDataDetails.push(elm);
              }
              this.currentTableDataDetailsForEmployee = this.tableDataDetails;
            }
          })


          this.currrentTableDataDetails = this.tableDataDetails;
          // For Team Reimbursement Condition here --- mnanager
          tableDataDetails.forEach((elm: any, i: any) => {

            if (this.loggedInUserId != elm.employeeId) {
              var arrEmployeeList = { "employeeId": elm.employeeId, "employeeName": elm.employeeName }
              // this.allListingEmployeeIdForTeam.push(arrEmployeeList)
              // Check if employeeId already exists in the array before pushing
              if (!this.allListingEmployeeIdForTeam.find((employee: { employeeId: any; }) => employee.employeeId === elm.employeeId)) {
                this.allListingEmployeeIdForTeam.push(arrEmployeeList);
                this.allListingEmployeeIdForTeam = this.allListingEmployeeIdForTeam.filter((record: any) => managerEmployeId.includes(record.employeeId));

              }

              // this.allTeamReimbursement.push(elm);
              // Check for duplicates before adding
              const isDuplicatelist = this.allTeamReimbursement.some(
                (item: any) => item.reimbursementApplicationId === elm.reimbursementApplicationId
              );

              if (!isDuplicatelist) {
                elm.managerStatus = elm.approvedByManager;
                this.allTeamReimbursement.push(elm);

                this.allTeamReimbursement = this.allTeamReimbursement.filter((record: any) => managerEmployeId.includes(record.employeeId));
              }
            }
          })
          console.error(this.allListingEmployeeIdForTeam);

          this.currrentTableDataDetails = this.allTeamReimbursement;

        } else if (this.loggedInUserRole === 'Employee') {
          console.log("Employee Login")

          tableDataDetails?.forEach((elm: any, i: any) => {
            if (this.loggedInUserId == elm.employeeId) {
              console.log("Emp In ");

              var arrEmployeeList = { "employeeId": elm.employeeId, "employeeName": elm.employeeName }

              const isDuplicate = this.allListingEmployeeId?.some(
                (employee: { employeeId: any }) => employee.employeeId === elm.employeeId
              );

              if (elm.approvedByManager === "APPROVED" && ((elm.financeId == null) || (elm.financeId == parseInt(this.loggedInUserId)))) {
                if (!isDuplicate) {
                  this.allListingEmployeeId.push(arrEmployeeList);
                }
              }

              // Avoid pushing duplicates into tableDataDetails

              let isDuplicateInTableData = this.tableDataDetails.some((existingElm: any) => existingElm.reimbursementApplicationId === elm.reimbursementApplicationId);

              if (!isDuplicateInTableData) {

                this.tableDataDetails.push(elm);
              }
              this.currentTableDataDetailsForEmployee = this.tableDataDetails;
            }
          });

          this.currrentTableDataDetails = this.tableDataDetails;   // For Employee


          // For Reimbursement Approve tab
          tableDataDetails.forEach((elm: any) => {
            // Add unique employee to allListingEmployeeId
            const arrEmployeeList = { employeeId: elm.employeeId, employeeName: elm.employeeName };

            const isDuplicate = this.allListingEmployeeId.some(
              (employee: { employeeId: any }) => employee.employeeId === elm.employeeId
            );


            // Filter and update approved reimbursements
            if (elm.approvedByManager === "APPROVED" && ((elm.financeId == null) || (elm.financeId == parseInt(this.loggedInUserId)))) {
              if (!isDuplicate) {
                this.allListingEmployeeId.push(arrEmployeeList);
              }
            }


            if (elm.financeId == parseInt(this.loggedInUserId)) {
              let arrExpenseList = { "reimbursementid": elm.reimbursementid, "reimbursementType": elm.reimbursementType };
              allExpensData.push(arrExpenseList);
              this.arrExpensTypeData = this.removeDuplicateExpensIds(allExpensData);
            }

            if (elm.approvedStatus == 'PENDING') {
              elm.approvedStatus = 'PENDING';
            } else if (elm.approvedStatus == 'REJECTED') {
              elm.approvedStatus = elm.approvedStatus;
              elm.financeStatus = elm.approvedStatus;
            } else {
              elm.approvedStatus = 'APPROVED';
              elm.financeStatus = elm.approvedStatus;
            }

            this.allTeamMemberReimbursementApprove.push(elm);
          });



          // Assign filtered approvals to currentallTeamMemberReimbursementApprove
          if (this.approveMatrixValueForCondition == 'EMPLOYEE_TO_FINANCE') {
            this.allTeamMemberReimbursementApprove = this.allTeamMemberReimbursementApprove.filter(
              (elm: any) => ((elm.financeId == null) || (elm.financeId == parseInt(this.loggedInUserId)))
            );
          } else {
            this.allTeamMemberReimbursementApprove = this.allTeamMemberReimbursementApprove.filter(
              (elm: any) => (elm.approvedByManager === "APPROVED" && ((elm.financeId == null) || (elm.financeId == parseInt(this.loggedInUserId))))
            );

          }

          //  NEW FLOW: EMPLOYEE → MANAGER → HR → FINANCE
          if (this.approveMatrixValueForCondition == 'EMPLOYEE_TO_MANAGER_TO_HR_TO_FINANCE') {
            this.allTeamMemberReimbursementApprove =
              this.allTeamMemberReimbursementApprove.filter((elm: any) =>
                elm.approvedByManager === "APPROVED" &&
                elm.approvedByHrAdmin === "APPROVED" &&
                (
                  elm.financeId == null ||
                  elm.financeId == parseInt(this.loggedInUserId)
                ) &&
                elm.status !== "REJECTED_BY_MANAGER" &&
                elm.status !== "REJECTED_BY_HR_ADMIN"
              );
          }


          // For Reimbursement Approve
          this.currentallTeamMemberReimbursementApprove = this.allTeamMemberReimbursementApprove;


        } else {
          console.log("Other Login")

          // allTeamMemberReimbursementApprove // for HR Admin

          tableDataDetails.forEach((elm: any, i: any) => {

            let arrExpenseList = { "reimbursementid": elm.reimbursementid, "reimbursementType": elm.reimbursementType };
            let arrEmployees = { "employeeId": elm.employeeId, "employeeName": elm.employeeName };
            allExpensData.push(arrExpenseList);
            arrEmployeesData.push(arrEmployees);

            const isDuplicate = this.allListingEmployeeId.some(
              (employee: { employeeId: any }) => employee.employeeId === elm.employeeId
            );
            // Filter for finance
            if (elm.approvedStatus == 'APPROVED' || elm.approvedStatus == 'REJECTED') {
              if (!isDuplicate) {
                this.fitergetAllFinanceUserDDHrAdmin.push(elm.financeId)
              }
            }
          })

          this.arrExpensTypeData = this.removeDuplicateExpensIds(allExpensData);


          const matchingUsers = this.getAllFinanceUserDD.filter((user: any) => this.fitergetAllFinanceUserDDHrAdmin.includes(user.id));


          this.fitergetAllFinanceUserDD = matchingUsers;

          this.allTeamMemberReimbursementApprove = tableDataDetails.filter(
            (data: { year: any; }) => data?.year === this.selectedYearForCompetency
          );

          this.allTeamMemberReimbursementApprove = this.allTeamMemberReimbursementApprove;
          this.currentallTeamMemberReimbursementApprove = this.allTeamMemberReimbursementApprove;

        }


      });


  }



  // function for  the band and the type dropdown
  isDropdownsPopulatedForFinance = false;
  populateDropdownsForFinance() {
    if (this.isDropdownsPopulatedForFinance) return true;

    if (this.loggedInUserRole === 'Finance' || this.financePerson === this.loggedInUserId) {
      this.filteredBandsForReimursement = this.getUniqueBands(this.allTeamMemberReimbursementApprove);
      this.filteredExpensTypeData = this.arrExpensTypeData.filter((type: any) =>
        this.allTeamMemberReimbursementApprove.some(
          (entry: any) =>
            entry.reimbursementid === type.reimbursementid &&
            entry.status !== 'REJECTED_BY_MANAGER'
        )
      );

      this.isDropdownsPopulatedForFinance = true;
    }

    return true;
  }


  // band for ficnace and manager
  getUniqueBands(data: any[]): any[] {
    const seen = new Set();
    return data
      .filter(item => {
        if (!seen.has(item.band) && item.band != null) {
          seen.add(item.band);
          return true;
        }
        return false;
      })
      .map(item => ({ band: item.band }));
  }

  // removeDuplicateExpensIds(data: any[]) {
  //   const seen = new Set();
  //   return data.filter((item) => {
  //     if (seen.has(item.reimbursementid)) {
  //       return false;
  //     }
  //     seen.add(item.reimbursementid);
  //     return true;
  //   });
  // }


  removeDuplicateExpensIds(data: any[]) {
    const seen = new Set();
    return data.filter((item) => {
      if (seen.has(item.reimbursementType)) {
        return false;
      }
      seen.add(item.reimbursementType);
      return true;
    });
  }



  getEmployeeForReimbursement(event: any): void {

    if (event == '-1') {
      this.allTeamReimbursement = this.currrentTableDataDetails;
    } else {
      // Use the original array to filter and update `tableDataDetails`.
      console.log(event);
      this.selectedBand = "-1";
      this.selectedLocation = "-1";
      this.selectedType = "-1"
      const updatedTableDataDetails = this.currrentTableDataDetails.filter((elm: any) => {

        return elm.employeeId === event;
      });


      // If matches are found, update the array with the new one.
      if (updatedTableDataDetails.length > 0) {

        this.allTeamReimbursement = updatedTableDataDetails;
      }

    }
  }

  // Select All Band
  selectedBand: any = "-1";
  // getBandForReimbursement(event: any) {
  //   if (this.loggedInUserRole !== 'HR Admin') {
  //     if (event == '-1') {

  //       this.allTeamMemberReimbursementApprove = this.currentallTeamMemberReimbursementApprove;
  //       // this.allListingEmployeeId = [];
  //       this.selectedBand = "-1";
  //       this.selectedLocation = "-1";
  //       this.selectedType = "-1"
  //     } else {
  //       this.selectedLocation = "-1";
  //       this.selectedType = "-1"
  //       const data = this.currentallTeamMemberReimbursementApprove;
  //       const updatedTableDataDetails = data.filter((elm: any) =>
  //         elm.band == event
  //       );

  //       console.log(updatedTableDataDetails);

  //       this.allTeamMemberReimbursementApprove = updatedTableDataDetails;
  //     }
  //   } else {

  //     if (event == '-1') {

  //       this.allTeamMemberReimbursementApprove = this.currentallTeamMemberReimbursementApprove.filter((elm: any) => elm.employeeId === this.selectedEmployee && elm.financeId == this.financeIdForEmployee);
  //       // this.allListingEmployeeId = [];
  //       this.selectedBand = "-1";
  //       this.selectedLocation = "-1";
  //       this.selectedType = "-1"
  //     } else {
  //       this.selectedLocation = "-1";
  //       this.selectedType = "-1"
  //       const data = this.currentallTeamMemberReimbursementApprove.filter((elm: any) => elm.employeeId === this.selectedEmployee && elm.financeId == this.financeIdForEmployee);
  //       // this.selectedEmployee = -1;


  //       // this.allListingEmployeeId = data;

  //       // Use the original array to filter and update `tableDataDetails`.
  //       console.log(data);


  //       const updatedTableDataDetails = data.filter((elm: any) =>
  //         elm.band == event
  //       );

  //       console.log(updatedTableDataDetails);

  //       this.allTeamMemberReimbursementApprove = updatedTableDataDetails;
  //     }
  //   }




  // }



  getBandForReimbursement(event: any) {
    this.selectedBand = event;
    this.selectedLocation = "-1";
    this.selectedType = "-1";
    this.filteredExpensTypeData = []; // Reset expense type dropdown

    if (this.loggedInUserRole !== 'HR Admin') {
      if (event == '-1') {
        this.allTeamMemberReimbursementApprove = this.currentallTeamMemberReimbursementApprove;
      } else {
        const updatedTableDataDetails = this.currentallTeamMemberReimbursementApprove.filter(
          (elm: any) => elm.band == event
        );
        this.allTeamMemberReimbursementApprove = updatedTableDataDetails;

        //  Filter Expense Types based on selected Band
        const uniqueExpenseTypes = new Map();
        updatedTableDataDetails.forEach((elm: { reimbursementid: any; reimbursementType: any; }) => {
          if (!uniqueExpenseTypes.has(elm.reimbursementid)) {
            uniqueExpenseTypes.set(elm.reimbursementid, {
              reimbursementid: elm.reimbursementid,
              reimbursementType: elm.reimbursementType
            });
          }
        });
        this.filteredExpensTypeData = Array.from(uniqueExpenseTypes.values());
      }
    } else {
      const employeeFilteredData = this.currentallTeamMemberReimbursementApprove.filter(
        (elm: any) => elm.employeeId === this.selectedEmployee && elm.financeId == this.financeIdForEmployee
      );

      if (event == '-1') {
        this.allTeamMemberReimbursementApprove = employeeFilteredData;
      } else {
        const updatedTableDataDetails = employeeFilteredData.filter(
          (elm: any) => elm.band == event
        );
        this.allTeamMemberReimbursementApprove = updatedTableDataDetails;

        //  Filter Expense Types for HR Admin too
        const uniqueExpenseTypes = new Map();
        updatedTableDataDetails.forEach((elm: { reimbursementid: any; reimbursementType: any; }) => {
          if (!uniqueExpenseTypes.has(elm.reimbursementid)) {
            uniqueExpenseTypes.set(elm.reimbursementid, {
              reimbursementid: elm.reimbursementid,
              reimbursementType: elm.reimbursementType
            });
          }
        });
        this.filteredExpensTypeData = Array.from(uniqueExpenseTypes.values());
      }
    }
  }

  //Select All Location
  selectedLocation: any = "-1";
  getLocationForReimbursement(event: any) {
    if (this.loggedInUserRole !== 'HR Admin') {
      if (event == '-1') {

        this.allTeamMemberReimbursementApprove = this.currentallTeamMemberReimbursementApprove.filter((elm: any) => elm.band === this.selectedBand);
        this.allListingEmployeeId = [];
        this.selectedLocation = "-1";
        this.selectedType = "-1"
      } else {
        this.selectedType = "-1"
        const data = this.currentallTeamMemberReimbursementApprove.filter((elm: any) => elm.band == this.selectedBand);
        // this.selectedEmployee = -1;


        this.allListingEmployeeId = data;

        // Use the original array to filter and update `tableDataDetails`.
        const updatedTableDataDetails = data.filter((elm: any) => elm.location === event);
        console.log(updatedTableDataDetails);

        this.allTeamMemberReimbursementApprove = updatedTableDataDetails;
      }
    } else {

      if (event == '-1') {

        this.allTeamMemberReimbursementApprove = this.currentallTeamMemberReimbursementApprove.filter((elm: any) => elm.employeeId === this.selectedEmployee && elm.financeId == this.financeIdForEmployee && elm.band == this.selectedBand);
        this.allListingEmployeeId = [];
        this.selectedLocation = "-1";
        this.selectedType = "-1"
      } else {
        this.selectedType = "-1"
        const data = this.currentallTeamMemberReimbursementApprove.filter((elm: any) => elm.location == event && elm.employeeId === this.selectedEmployee && elm.financeId == this.financeIdForEmployee && elm.band == this.selectedBand);
        // this.selectedEmployee = -1;


        this.allListingEmployeeId = data;

        // Use the original array to filter and update `tableDataDetails`.
        const updatedTableDataDetails = data.filter((elm: any) => elm.location === event);
        console.log(updatedTableDataDetails);

        this.allTeamMemberReimbursementApprove = updatedTableDataDetails;
      }
    }
  }


  // For Select Expense Type
  selectedType: any = '-1';
  getExpensTypeForReimbursement(event: any) {
    this.selectedType = event;

    // for Finance login without employee selection
    if (
      (this.loggedInUserRole === 'Finance' || this.financePerson === this.loggedInUserId) &&
      this.loggedInUserRole !== 'HR Admin' &&
      !this.selectedEmployee // Employee dropdown not available
    ) {
      if (event == '-1') {
        this.allTeamMemberReimbursementApprove = this.currentallTeamMemberReimbursementApprove.filter(
          (elm: any) =>
            elm.band === this.selectedBand &&
            elm.location === this.selectedLocation
        );
        this.allListingEmployeeId = [];
        this.selectedType = "-1";
      } else {
        const filteredData = this.currentallTeamMemberReimbursementApprove.filter(
          (elm: any) =>
            elm.band === this.selectedBand &&
            elm.location === this.selectedLocation &&
            elm.reimbursementid == event
        );
        this.allTeamMemberReimbursementApprove = filteredData;
        this.allListingEmployeeId = filteredData;
      }
      return;
    }

    if (this.loggedInUserRole !== 'HR Admin') {
      if (event == '-1') {
        console.error(this.currentallTeamMemberReimbursementApprove);

        this.allTeamMemberReimbursementApprove = this.currentallTeamMemberReimbursementApprove.filter((elm: any) => elm.band == this.selectedBand && elm.location === this.selectedLocation);
        this.allListingEmployeeId = [];
        this.selectedType = "-1";
      } else {
        console.error(event);

        const data = this.currentallTeamMemberReimbursementApprove.filter((elm: any) => elm.band == this.selectedBand && elm.location === this.selectedLocation);
        // this.selectedEmployee = -1;


        this.allListingEmployeeId = data;

        // Use the original array to filter and update `tableDataDetails`.
        const updatedTableDataDetails = data.filter((elm: any) => elm.reimbursementid === event);
        this.allTeamMemberReimbursementApprove = updatedTableDataDetails;
      }
    } else {
      if (event == '-1') {
        console.error(this.currentallTeamMemberReimbursementApprove);

        this.allTeamMemberReimbursementApprove = this.currentallTeamMemberReimbursementApprove.filter((elm: any) => elm.employeeId === this.selectedEmployee && elm.financeId == this.financeIdForEmployee && elm.band == this.selectedBand && elm.location === this.selectedLocation);
        this.allListingEmployeeId = [];
        this.selectedType = "-1";
      } else {
        console.error(event);

        const data = this.currentallTeamMemberReimbursementApprove.filter((elm: any) => elm.reimbursementid == event && elm.employeeId === this.selectedEmployee && elm.financeId == this.financeIdForEmployee && elm.band == this.selectedBand && elm.location === this.selectedLocation);
        // this.selectedEmployee = -1;


        this.allListingEmployeeId = data;

        // Use the original array to filter and update `tableDataDetails`.
        const updatedTableDataDetails = data.filter((elm: any) => elm.reimbursementid === event);
        this.allTeamMemberReimbursementApprove = updatedTableDataDetails;
      }
    }


    //check user list by finance admin


  }







  financeIdForEmployee: number = -1; // Default value
  filteredExpensTypeData: any[] = [];

  getEmployeeForReimbursementApprove(event: any): void {
    this.selectedEmployee = event;

    if (this.loggedInUserRole != 'HR Admin') {

      if (event == '-1') {
        this.selectedBand = "-1";
        this.selectedLocation = "-1";
        this.selectedType = "-1"
        this.allTeamMemberReimbursementApprove = this.currentallTeamMemberReimbursementApprove;
        this.filterBandsForSelectedEmployee(event);
        this.filteredExpensTypeData = [...this.arrExpensTypeData];

      } else {
        this.selectedBand = "-1";
        this.selectedLocation = "-1";
        this.selectedType = "-1"
        // Use the original array to filter and update `tableDataDetails`.
        const updatedTableDataDetails = this.currentallTeamMemberReimbursementApprove.filter((elm: any) => {

          return elm.employeeId === event;
        });

        // If matches are found, update the array with the new one.
        if (updatedTableDataDetails.length > 0) {

          this.allTeamMemberReimbursementApprove = updatedTableDataDetails;
        }
        this.filterBandsForSelectedEmployee(event);
        this.filteredExpensTypeData = this.arrExpensTypeData.filter((type: any) =>
          this.currentallTeamMemberReimbursementApprove.some(
            (entry: any) =>
              entry.employeeId === event &&
              entry.reimbursementid === type.reimbursementid &&
              entry.status !== 'REJECTED_BY_MANAGER'
          )
        );
      }
    } else {



      if (event == '-1') {


        this.allTeamMemberReimbursementApprove = this.allTeamMemberReimbursementApprove;
        this.selectedBand = "-1";
        this.selectedLocation = "-1";
        this.selectedType = "-1"
        this.filterBandsForSelectedEmployee(event);
        this.filteredExpensTypeData = [...this.arrExpensTypeData];
        // this.allTeamMemberReimbursementApprove = this.currentallTeamMemberReimbursementApprove.filter((elm:any)=>elm.financeId==this.financeIdForEmployee);
      } else {
        this.selectedBand = "-1";
        this.selectedLocation = "-1";
        this.selectedType = "-1"
        const data = this.currentallTeamMemberReimbursementApprove.filter((elm: any) => (elm.financeId == this.financeIdForEmployee && elm.employeeId == event));

        this.allTeamMemberReimbursementApprove = data;
        this.filterBandsForSelectedEmployee(event);
        this.filteredExpensTypeData = this.arrExpensTypeData.filter((type: any) =>
          this.currentallTeamMemberReimbursementApprove.some(
            (entry: any) =>
              entry.employeeId === event &&
              entry.reimbursementid === type.reimbursementid &&
              entry.status !== 'REJECTED_BY_MANAGER'
          )
        );

      }
    }
  }

  filteredBandsForReimursement: any[] = []
  //  Filter band dropdown based on selected employee
  filterBandsForSelectedEmployee(employeeId: any) {
    if (employeeId === '-1') {
      // Show all bands if "Select All Employee" is selected
      this.filteredBandsForReimursement = [...this.arrBandsForReimursement];

    } else {
      const matchedEmp = this.arrEmployeeDetiailsBandLocation.find((emp: any) => emp.id == employeeId);
      if (matchedEmp?.band) {
        this.filteredBandsForReimursement = this.arrBandsForReimursement.filter((b: { band: any; }) => b.band === matchedEmp.band);
        console.log("filtered band here===........", this.filteredBandsForReimursement);

      } else {
        this.filteredBandsForReimursement = [];
      }
    }
  }


  // For Year Select
  viewReimbursementReportByYear(year: any) {
    this.selectedYearForCompetency = year;

    const years = year.split('-')[0];  // This gives "2026"

    const today = new Date();

    const baseStartDate = new Date(today);
    baseStartDate.setDate(today.getDate() - 12);

    const baseEndDate = new Date(today);
    baseEndDate.setDate(today.getDate() + 2);

    const startDate = this.getSafeDateWithNewYear(baseStartDate, years);
    const endDate = this.getSafeDateWithNewYear(baseEndDate, years);

    if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
      console.error('Invalid start or end date:', startDate, endDate);
      return;
    }

    this.taskFromDate = startDate.toISOString().split('T')[0];
    this.taskToDate = endDate.toISOString().split('T')[0];

    this.getAllEmployeeListing();
  }

  getSafeDateWithNewYear(originalDate: Date, year: number | string): Date {
    // Ensure year is a number
    const newYear = Number(year);
    if (isNaN(newYear)) {
      console.error('Invalid year passed:', year);
      return new Date(NaN); // invalid date
    }

    // Create new date with new year, but same month & day as originalDate
    const newDate = new Date(originalDate);
    newDate.setFullYear(newYear);

    // Validate new date
    if (isNaN(newDate.getTime())) {
      console.error('Invalid date generated:', newDate);
    }

    return newDate;
  }

  selectedEmployee: any = -1;

  // For Select Finance 
  getFinaceForReimbursement(event: any) {
    if (this.loggedInUserRole != 'HR Admin' && this.loggedInUserRole != 'Super Admin') {

      if (event == '-1') {
        this.isShowSelectEmployee = false;
        this.tableDataDetails = this.currrentTableDataDetails;
        // this.allListingEmployeeId = [];
        this.selectedEmployee = -1;
        this.selectedBand = "-1";
        this.selectedLocation = "-1";
        this.selectedType = "-1"
      } else {
        // Use the original array to filter and update `tableDataDetails`.
        this.selectedEmployee = -1;

        this.selectedBand = "-1";
        this.selectedLocation = "-1";
        this.selectedType = "-1"
        const updatedTableDataDetails = this.currrentTableDataDetails.filter((elm: any) => {

          return elm.employeeId === event;
        });

        // If matches are found, update the array with the new one.
        if (updatedTableDataDetails.length > 0) {
          this.isShowSelectEmployee = true;
          this.tableDataDetails = updatedTableDataDetails;
        }

      }
    } else {
      console.log("HRADMIN LOGIN")
      if (event == '-1') {
        this.isShowSelectEmployee = false;
        this.allTeamMemberReimbursementApprove = this.currentallTeamMemberReimbursementApprove;
        this.allListingEmployeeId = [];
        this.selectedEmployee = -1;
        this.selectedBand = "-1";
        this.selectedLocation = "-1";
        this.selectedType = "-1"
      } else {
        this.isShowSelectEmployee = true;
        const data = this.currentallTeamMemberReimbursementApprove.filter((elm: any) => elm.financeId == event);
        this.selectedEmployee = -1;

        this.selectedBand = "-1";
        this.selectedLocation = "-1";
        this.selectedType = "-1"
        const uniqueData = data.filter((item: any, index: any, self: any) =>
          index === self.findIndex((t: any) => t.employeeId === item.employeeId)
        );


        this.allListingEmployeeId = uniqueData;

        // Use the original array to filter and update `tableDataDetails`.
        const updatedTableDataDetails = data.filter((elm: any) => elm.financeId === event);
        this.allTeamMemberReimbursementApprove = updatedTableDataDetails;
      }

    }

    //check user list by finance admin


  }

  empReimbursementTable() {

    //For Employee Header Column configuation
    const commonColumns = [
      { headerName: 'Reimbursement Type', isMandatory: true, minWidth: 210, filter: 'agSetColumnFilter', field: 'reimbursementType' },
      {
        headerName: 'Date of Apply',
        field: 'date',
        cellRenderer: (params: any) => this.dateRenderer(params),
        comparator: (valueA: string, valueB: string) => this.dateComparator(valueA, valueB),
        filter: 'agDateColumnFilter',
        minWidth: 165,
        filterParams: {
          filterOptions: ['equals', 'inRange', 'blank', 'notBlank'],
          suppressAndOrCondition: true,  // ✅ AND/OR hide
          maxNumConditions: 1            // ✅ Sirf ek condition allow hogi
        }
      }, {
        headerName: 'Date of Expense',
        isMandatory: true,
        field: 'dateOfExpense',
        cellRenderer: (params: any) => this.dateRenderer(params),
        comparator: (valueA: string, valueB: string) => this.dateComparator(valueA, valueB),
        filter: 'agDateColumnFilter',
        minWidth: 180,
        filterParams: {
          filterOptions: ['equals', 'inRange', 'blank', 'notBlank'],
          suppressAndOrCondition: true,  // ✅ AND/OR hide
          maxNumConditions: 1            // ✅ Sirf ek condition allow hogi
        }
      },
      { headerName: 'Limit of Reimbursement', isMandatory: true, minWidth: 230, filter: 'agSetColumnFilter', field: 'reimbursementLimit' },
      { headerName: 'Actual Amount', isMandatory: true, minWidth: 170, filter: 'agSetColumnFilter', field: 'actualAmount' },
      { headerName: 'Actual Amount By Finance', isMandatory: true, minWidth: 250, filter: 'agSetColumnFilter', field: 'assignedAmount' },
      { headerName: 'Attachment', isMandatory: true, field: 'uploadDocument', cellRenderer: (params: any) => this.downloadRenderer(params), filter: false, minWidth: 135 },
      {
        headerName: 'Status',
        field: 'status',
        cellRenderer: (params: any) => this.statusFormatter(params),
        filter: 'agSetColumnFilter',
        minWidth: 180,
        autoHeight: true, // ✅ ensures row height adjusts to wrapped text
        cellStyle: { whiteSpace: 'normal' }
      },
      {
        headerName: 'Employee Comment',
        isMandatory: false,
        field: 'employeeComment',
        filter: 'agSetColumnFilter',
        minWidth: 210,
        cellRenderer: (params: any) => {
          if (!params.value) return ''; // null/undefined case me blank return karega
          const shortText = params.value?.length > 30
            ? params.value.substring(0, 30) + '...'
            : params.value;

          return `<span class="clickable-comment">${shortText}</span>`;
        },
        onCellClicked: (params: any) => {
          if (params.value) {
            // console.log(params)
            params.context.componentParent.openCommentModal(params.value, 'Employee');
          }
        }
      },
      {
        headerName: 'Finance Comment',
        isMandatory: false,
        field: 'financeComment',
        filter: 'agSetColumnFilter',
        minWidth: 210,
        cellRenderer: (params: any) => {
          if (!params.value) return ''; // null/undefined case me blank return karega

          const shortText = params.value?.length > 30
            ? params.value.substring(0, 30) + '...'
            : params.value;

          return `<span class="clickable-comment">${shortText}</span>`;
        },
        onCellClicked: (params: any) => {
          if (params.value) {
            // console.log(params)
            params.context.componentParent.openCommentModal(params.value, 'Finance');
          }
        }
      },
      {
        headerName: 'Approved Status',
        isMandatory: true,
        field: 'approvedStatus',
        cellRenderer: (params: any) => this.approvalRenderer(params),
        filter: 'agSetColumnFilter',
        minWidth: 190
      }

    ];

    if (this.approveMatrixValueForCondition !== 'EMPLOYEE_TO_FINANCE') {

      const managerCommentColumn = {
        headerName: 'Manager Comment',
        isMandatory: false,
        field: 'managerComment',
        filter: 'agSetColumnFilter',
        minWidth: 210,
        cellRenderer: (params: any) => {
          if (!params.value) return ''; // null/undefined case me blank return karega
          const shortText = params.value?.length > 30
            ? params.value.substring(0, 30) + '...'
            : params.value;

          return `<span class="clickable-comment">${shortText}</span>`;
        },
        onCellClicked: (params: any) => {
          if (params.value) {
            // console.log(params)
            params.context.componentParent.openCommentModal(params.value, 'Manager');
          }
        }
      };
      const employeeCommentIndex = commonColumns.findIndex(column => column.field === 'employeeComment');
      commonColumns.splice(employeeCommentIndex + 1, 0, managerCommentColumn);
    }

    // if (this.approveMatrixValueForCondition !== 'EMPLOYEE_TO_FINANCE') {
    //   const managerCommentColumn = { headerName: 'Manager comment', isMandatory: true, minWidth: 180,filter: 'agSetColumnFilter', field: 'managerComment' };
    //   const employeeCommentIndex = commonColumns.findIndex(column => column.field === 'employeeComment');
    //   commonColumns.splice(employeeCommentIndex + 1, 0, managerCommentColumn);
    // }

    this.taskColumnHeaderInfo = commonColumns;

    const taskColumnHeaderInfoForManager = [
      { headerName: 'Employee Name', isMandatory: true, minWidth: 190, filter: 'agSetColumnFilter', field: 'employeeName' },
      { headerName: 'Reimbursement Type', isMandatory: true, minWidth: 220, filter: 'agSetColumnFilter', field: 'reimbursementType' },
      {
        headerName: 'Date of Apply',
        field: 'date',
        cellRenderer: (params: any) => this.dateRenderer(params),
        comparator: (valueA: string, valueB: string) => this.dateComparator(valueA, valueB),
        filter: 'agDateColumnFilter',
        minWidth: 165,
        filterParams: {
          filterOptions: ['equals', 'inRange', 'blank', 'notBlank'],
          suppressAndOrCondition: true,  // ✅ AND/OR hide
          maxNumConditions: 1            // ✅ Sirf ek condition allow hogi
        }
      },
      {
        headerName: 'Date of Expense',
        isMandatory: true,
        field: 'dateOfExpense',
        cellRenderer: (params: any) => this.dateRenderer(params),
        comparator: (valueA: string, valueB: string) => this.dateComparator(valueA, valueB),
        filter: 'agDateColumnFilter',
        minWidth: 185,
        filterParams: {
          filterOptions: ['equals', 'inRange', 'blank', 'notBlank'],
          suppressAndOrCondition: true,  // ✅ AND/OR hide
          maxNumConditions: 1            // ✅ Sirf ek condition allow hogi
        }
      },
      // { headerName: 'Reimbursement Id', isMandatory: true,minWidth: 180 , filter: 'agSetColumnFilter', field: 'reimbursementId' },
      { headerName: 'Limit of Reimbursement', isMandatory: true, minWidth: 230, filter: 'agSetColumnFilter', field: 'reimbursementLimit' },
      { headerName: 'Actual Amount', isMandatory: true, minWidth: 180, filter: 'agSetColumnFilter', field: 'actualAmount' },
      { headerName: 'Actual Amount By Finance', isMandatory: true, minWidth: 250, filter: 'agSetColumnFilter', field: 'assignedAmount' },
      { headerName: 'Attachment', isMandatory: true, field: 'uploadDocument', cellRenderer: (params: any) => this.downloadRenderer(params), filter: false, minWidth: 135 },
      {
        headerName: 'Status',
        field: 'status',
        cellRenderer: (params: any) => this.statusFormatter(params),
        filter: 'agSetColumnFilter',
        minWidth: 180,
        autoHeight: true, // ✅ ensures row height adjusts to wrapped text
        cellStyle: { whiteSpace: 'normal' }
      },
      {
        headerName: 'Employee Comment',
        isMandatory: false,
        field: 'employeeComment',
        filter: 'agSetColumnFilter',
        minWidth: 210,
        cellRenderer: (params: any) => {
          if (!params.value) return ''; // null/undefined case me blank return karega
          const shortText = params.value?.length > 30
            ? params.value.substring(0, 30) + '...'
            : params.value;

          return `<span class="clickable-comment">${shortText}</span>`;
        },
        onCellClicked: (params: any) => {
          if (params.value) {
            // console.log(params)
            params.context.componentParent.openCommentModal(params.value, 'Employee');
          }
        }
      },

      {
        headerName: 'Finance Comment',
        isMandatory: false,
        field: 'financeComment',
        filter: 'agSetColumnFilter',
        minWidth: 210,
        cellRenderer: (params: any) => {
          if (!params.value) return ''; // null/undefined case me blank return karega

          const shortText = params.value?.length > 30
            ? params.value.substring(0, 30) + '...'
            : params.value;

          return `<span class="clickable-comment">${shortText}</span>`;
        },
        onCellClicked: (params: any) => {
          if (params.value) {
            // console.log(params)
            params.context.componentParent.openCommentModal(params.value, 'Finance');
          }
        }
      }
      ,
      {
        headerName: 'Approval',
        isMandatory: true,
        field: 'approvedStatus',
        cellRenderer: (params: any) => this.approvalRenderer(params),
        filter: 'agSetColumnFilter',
        minWidth: 150
      }

    ];
    if (this.approveMatrixValueForCondition !== 'EMPLOYEE_TO_FINANCE') {
      const managerCommentColumn = {
        headerName: 'Manager Comment',
        isMandatory: false,
        field: 'managerComment',
        filter: 'agSetColumnFilter',
        minWidth: 210,
        cellRenderer: (params: any) => {
          if (!params.value) return ''; // null/undefined case me blank return karega
          const shortText = params.value?.length > 30
            ? params.value.substring(0, 30) + '...'
            : params.value;

          return `<span class="clickable-comment">${shortText}</span>`;
        },
        onCellClicked: (params: any) => {
          if (params.value) {
            // console.log(params)
            params.context.componentParent.openCommentModal(params.value, 'Manager');
          }
        }
      };
      const employeeCommentIndex = taskColumnHeaderInfoForManager.findIndex(column => column.field === 'employeeComment');
      taskColumnHeaderInfoForManager.splice(employeeCommentIndex + 1, 0, managerCommentColumn);
    }

    this.taskColumnHeaderInfoForManager = taskColumnHeaderInfoForManager;

    const taskColumnHeaderInfoForFinanse = [
      { headerName: 'Employee Name', isMandatory: true, field: 'employeeName', filter: 'agSetColumnFilter', minWidth: 190 },
      { headerName: 'Reimbursement Type', isMandatory: true, field: 'reimbursementType', filter: 'agSetColumnFilter', minWidth: 220 },
      { headerName: 'Location', isMandatory: true, field: 'location', filter: 'agSetColumnFilter', minWidth: 130 },
      { headerName: 'Band', isMandatory: true, field: 'band', filter: 'agSetColumnFilter', minWidth: 110 },
      // { headerName: 'Date of Apply', isMandatory: true, field: 'date' , cellRenderer: (params: any) => this.dateFilterComparator(params), filter: 'agSetColumnFilter',minWidth: 180 },
      {
        headerName: 'Date of Apply',
        field: 'date',
        cellRenderer: (params: any) => this.dateRenderer(params),
        comparator: (valueA: string, valueB: string) => this.dateComparator(valueA, valueB),
        filter: 'agDateColumnFilter',
        minWidth: 165,
        filterParams: {
          filterOptions: ['equals', 'inRange', 'blank', 'notBlank'],
          suppressAndOrCondition: true,  // ✅ AND/OR hide
          maxNumConditions: 1            // ✅ Sirf ek condition allow hogi
        }
      },
      {
        headerName: 'Date of Expense',
        isMandatory: true,
        field: 'dateOfExpense',
        cellRenderer: (params: any) => this.dateRenderer(params),
        comparator: (valueA: string, valueB: string) => this.dateComparator(valueA, valueB),
        filter: 'agDateColumnFilter',
        minWidth: 185,
        filterParams: {
          filterOptions: ['equals', 'inRange', 'blank', 'notBlank'],
          suppressAndOrCondition: true,  // ✅ AND/OR hide
          maxNumConditions: 1            // ✅ Sirf ek condition allow hogi
        }
      },
      { headerName: 'Limit of Reimbursement', isMandatory: true, field: 'reimbursementLimit', filter: 'agSetColumnFilter', minWidth: 230 },
      { headerName: 'Actual Amount', isMandatory: true, field: 'actualAmount', filter: 'agSetColumnFilter', minWidth: 180 },
      { headerName: 'Actual Amount By Finance', isMandatory: true, field: 'assignedAmount', filter: 'agSetColumnFilter', minWidth: 250 },
      { headerName: 'Attachment', isMandatory: true, field: 'uploadDocument', cellRenderer: (params: any) => this.downloadRenderer(params), filter: false, minWidth: 135 },
      {
        headerName: 'Status',
        field: 'status',
        cellRenderer: (params: any) => this.statusFormatter(params),
        filter: 'agSetColumnFilter',
        minWidth: 180,
        autoHeight: true, // ✅ ensures row height adjusts to wrapped text
        cellStyle: { whiteSpace: 'normal' }
      },

      {
        headerName: 'Employee Comment',
        isMandatory: false,
        field: 'employeeComment',
        filter: 'agSetColumnFilter',
        minWidth: 210,
        cellRenderer: (params: any) => {
          if (!params.value) return ''; // null/undefined case me blank return karega
          const shortText = params.value?.length > 30
            ? params.value.substring(0, 30) + '...'
            : params.value;

          return `<span class="clickable-comment">${shortText}</span>`;
        },
        onCellClicked: (params: any) => {
          if (params.value) {
            // console.log(params)
            params.context.componentParent.openCommentModal(params.value, 'Employee');
          }
        }
      },
      {
        headerName: 'Finance Comment',
        isMandatory: false,
        field: 'financeComment',
        filter: 'agSetColumnFilter',
        minWidth: 210,
        cellRenderer: (params: any) => {
          if (!params.value) return ''; // null/undefined case me blank return karega

          const shortText = params.value?.length > 30
            ? params.value.substring(0, 30) + '...'
            : params.value;

          return `<span class="clickable-comment">${shortText}</span>`;
        },
        onCellClicked: (params: any) => {
          if (params.value) {
            // console.log(params)
            params.context.componentParent.openCommentModal(params.value, 'Finance');
          }
        }
      }
      ,

      {
        headerName: 'Approval',
        isMandatory: true,
        field: 'approvedStatus',
        cellRenderer: (params: any) => this.approvalRenderer(params),
        filter: 'agSetColumnFilter',
        minWidth: 150
      }


    ];

    if (this.approveMatrixValueForCondition !== 'EMPLOYEE_TO_FINANCE') {

      const managerCommentColumn = {
        headerName: 'Manager Comment',
        isMandatory: false,
        field: 'managerComment',
        filter: 'agSetColumnFilter',
        minWidth: 210,
        cellRenderer: (params: any) => {
          if (!params.value) return ''; // null/undefined case me blank return karega
          const shortText = params.value?.length > 30
            ? params.value.substring(0, 30) + '...'
            : params.value;

          return `<span class="clickable-comment">${shortText}</span>`;
        },
        onCellClicked: (params: any) => {
          if (params.value) {
            // console.log(params)
            params.context.componentParent.openCommentModal(params.value, 'Manager');
          }
        }
      };
      const employeeCommentIndex = taskColumnHeaderInfoForFinanse.findIndex(column => column.field === 'employeeComment');
      taskColumnHeaderInfoForFinanse.splice(employeeCommentIndex + 1, 0, managerCommentColumn);
    }



    const taskColumnHeaderInfoForFinanceHRAdmin = [
      { headerName: 'Employee Name', isMandatory: true, filter: 'agSetColumnFilter', minWidth: 190, field: 'employeeName' },
      { headerName: 'Reimbursement Type', isMandatory: true, filter: 'agSetColumnFilter', minWidth: 220, field: 'reimbursementType' },
      { headerName: 'Location', isMandatory: true, filter: 'agSetColumnFilter', minWidth: 130, field: 'location' },
      { headerName: 'Band', isMandatory: true, filter: 'agSetColumnFilter', minWidth: 130, field: 'band' },
      {
        headerName: 'Date of Apply',
        field: 'date',
        cellRenderer: (params: any) => this.dateRenderer(params),
        comparator: (valueA: string, valueB: string) => this.dateComparator(valueA, valueB),
        filter: 'agDateColumnFilter',
        minWidth: 165,
        filterParams: {
          filterOptions: ['equals', 'inRange', 'blank', 'notBlank'],
          suppressAndOrCondition: true,  // ✅ AND/OR hide
          maxNumConditions: 1            // ✅ Sirf ek condition allow hogi
        }
      },
      {
        headerName: 'Date of Expense',
        isMandatory: true,
        field: 'dateOfExpense',
        cellRenderer: (params: any) => this.dateRenderer(params),
        comparator: (valueA: string, valueB: string) => this.dateComparator(valueA, valueB),
        filter: 'agDateColumnFilter',
        minWidth: 175,
        filterParams: {
          filterOptions: ['equals', 'inRange', 'blank', 'notBlank'],
          suppressAndOrCondition: true,  // ✅ AND/OR hide
          maxNumConditions: 1            // ✅ Sirf ek condition allow hogi
        }
      },
      { headerName: 'Limit of Reimbursement', isMandatory: true, filter: 'agSetColumnFilter', minWidth: 230, field: 'reimbursementLimit' },
      { headerName: 'Actual Amount', isMandatory: true, filter: 'agSetColumnFilter', minWidth: 180, field: 'actualAmount' },
      { headerName: 'Actual Amount By Finance', isMandatory: true, filter: 'agSetColumnFilter', minWidth: 250, field: 'assignedAmount' },
      { headerName: 'Attachment', isMandatory: true, field: 'uploadDocument', cellRenderer: (params: any) => this.downloadRenderer(params), filter: false, minWidth: 140 },
      {
        headerName: 'Status',
        field: 'status',
        cellRenderer: (params: any) => this.statusFormatter(params),
        filter: 'agSetColumnFilter',
        minWidth: 180,
        autoHeight: true, // ✅ ensures row height adjusts to wrapped text
        cellStyle: { whiteSpace: 'normal' }
      },
      {
        headerName: 'Employee Comment',
        isMandatory: false,
        field: 'employeeComment',
        filter: 'agSetColumnFilter',
        minWidth: 210,
        cellRenderer: (params: any) => {
          if (!params.value) return ''; // null/undefined case me blank return karega
          const shortText = params.value?.length > 30
            ? params.value.substring(0, 30) + '...'
            : params.value;

          return `<span class="clickable-comment">${shortText}</span>`;
        },
        onCellClicked: (params: any) => {
          if (params.value) {
            // console.log(params)
            params.context.componentParent.openCommentModal(params.value, 'Employee');
          }
        }
      },
      {
        headerName: 'Finance Comment',
        isMandatory: false,
        field: 'financeComment',
        filter: 'agSetColumnFilter',
        minWidth: 210,
        cellRenderer: (params: any) => {
          if (!params.value) return ''; // null/undefined case me blank return karega

          const shortText = params.value?.length > 30
            ? params.value.substring(0, 30) + '...'
            : params.value;

          return `<span class="clickable-comment">${shortText}</span>`;
        },
        onCellClicked: (params: any) => {
          if (params.value) {
            // console.log(params)
            params.context.componentParent.openCommentModal(params.value, 'Finance');
          }
        }
      },
      {
        headerName: 'Approval',
        isMandatory: true,
        field: 'approvedStatus',
        cellRenderer: (params: any) => this.approvalRenderer(params),
        filter: 'agSetColumnFilter',
        minWidth: 150
      }

    ];
    if (this.approveMatrixValueForCondition !== 'EMPLOYEE_TO_FINANCE') {
      const managerCommentColumn = {
        headerName: 'Manager Comment',
        isMandatory: false,
        field: 'managerComment',
        filter: 'agSetColumnFilter',
        minWidth: 210,
        cellRenderer: (params: any) => {
          if (!params.value) return ''; // null/undefined case me blank return karega
          const shortText = params.value?.length > 30
            ? params.value.substring(0, 30) + '...'
            : params.value;

          return `<span class="clickable-comment">${shortText}</span>`;
        },
        onCellClicked: (params: any) => {
          if (params.value) {
            // console.log(params)
            params.context.componentParent.openCommentModal(params.value, 'Manager');
          }
        }
      };

      const employeeCommentIndex = taskColumnHeaderInfoForFinanceHRAdmin.findIndex(column => column.field === 'employeeComment');
      taskColumnHeaderInfoForFinanceHRAdmin.splice(employeeCommentIndex + 1, 0, managerCommentColumn);
    }
    this.taskColumnHeaderInfoForFinanse = (this.loggedInUserRole == 'HR Admin') ? taskColumnHeaderInfoForFinanceHRAdmin : taskColumnHeaderInfoForFinanse;

  }



  viewDocument(fileUrl: string): void {

    if (fileUrl) {
      // Open the document in a new tab
      fileUrl = `${this.config.downloadFile}${fileUrl}`;
      window.open(fileUrl, '_blank');
    } else {
      console.error('No document URL available');
    }
  }



  // Function to filter data according to the selected page size

  taskFromDate: any;
  taskToDate: any;
  filteredData: any[] = []; // Holds the filtered data

  onDateChangeDashboard(defaultFromDate?: any, defaultToDate?: any): void {
    console.log("onDateChangeDashboard Report")
    this.taskFromDate = defaultFromDate;
    this.taskToDate = defaultToDate;
    if (this.taskFromDate && this.taskToDate) {
      const fromDate = new Date(this.taskFromDate);
      const toDate = new Date(this.taskToDate);

      // Ensure both dates are set to midnight in their respective local time zones
      fromDate.setHours(0, 0, 0, 0);  // Start of the day in local time
      toDate.setHours(23, 59, 59, 999); // End of the day in local time

      // Function to format dates to the desired ISO format with UTC (+00:00)
      const toISOWithUTCOffset = (date: Date): string => {
        const pad = (num: number): string => String(num).padStart(2, '0');
        const year = date.getFullYear();
        const month = pad(date.getMonth() + 1); // Months are zero-based
        const day = pad(date.getDate());

        return `${year}-${month}-${day}T00:00:00.000+00:00`;
      };

      // Format both dates to the start and end of the day in local time
      const formattedFromDate = toISOWithUTCOffset(fromDate);
      const formattedToDate = toISOWithUTCOffset(toDate);


      if (this.loggedInUserRole == 'Employee') {
        console.log(" Only Employee");
        // Proceed with filtering the data
        const filteredData = this.currrentTableDataDetails.filter((item: any) => {
          const itemDate = new Date(item.date); // Parse item.date to Date object
          return (
            itemDate >= new Date(formattedFromDate) &&
            itemDate <= new Date(formattedToDate)
          );
        });


        // Update the table data for rendering
        this.tableDataDetails = filteredData;


        const filteredDataForFinance = this.currentallTeamMemberReimbursementApprove.filter((item: any) => {
          // Filtering condition
          const itemDate = item.date; // Parse item.date to Date object
          return (
            itemDate >= formattedFromDate &&
            itemDate <= formattedToDate
          );


        });

        this.allTeamMemberReimbursementApprove = filteredDataForFinance;

      } else if ((this.loggedInUserRole == 'Manager' || this.loggedInHODManager == 'HODManager' || this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'MD')) {

        if ((this.loggedInUserRole == 'Manager' || this.loggedInHODManager == 'HODManager' || this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'MD') && this.financePerson == this.loggedInUserId) {
          console.log("Manager And Finance");
          if (this.selectedTypeTabName == 'Employee') {
            const filteredData = this.currentTableDataDetailsForEmployee.filter((item: any) => {
              const itemDate = new Date(item.date); // Parse item.date to Date object
              return (
                itemDate >= new Date(formattedFromDate) &&
                itemDate <= new Date(formattedToDate)
              );
            });
            this.tableDataDetails = filteredData;
          } else if (this.selectedTypeTabName == 'Finance') {
            const filteredData = this.currentallTeamMemberReimbursementApprove.filter((item: any) => {
              const itemDate = new Date(item.date); // Parse item.date to Date object
              return (
                itemDate >= new Date(formattedFromDate) &&
                itemDate <= new Date(formattedToDate)
              );
            });
            this.allTeamMemberReimbursementApprove = filteredData;
          } else {
            const filteredData = this.currrentTableDataDetails.filter((item: any) => {
              const itemDate = new Date(item.date); // Parse item.date to Date object
              return (
                itemDate >= new Date(formattedFromDate) &&
                itemDate <= new Date(formattedToDate)
              );
            });
            this.allTeamReimbursement = filteredData;

          }

        } else {
          console.log(" Only Manager");
          const filteredData = this.allTeamReimbursement.filter((item: any) => {
            const itemDate = new Date(item.date); // Parse item.date to Date object
            return (
              itemDate >= new Date(formattedFromDate) &&
              itemDate <= new Date(formattedToDate)
            );
          });
          this.allTeamReimbursement = filteredData;

        }
      }
      else if (this.loggedInUserRole == 'HR Admin') {

        const filteredData = this.currentallTeamMemberReimbursementApprove.filter((item: any) => {
          // Filtering condition
          const itemDate = item.date; // Parse item.date to Date object
          return (
            itemDate >= formattedFromDate &&
            itemDate <= formattedToDate
          );


        });

        this.allTeamMemberReimbursementApprove = filteredData;
      }
    } else {
      console.log('No filtering applied, returning all data');
    }
  }
  pmsYears: any = []
  selectedYearForCompetency: any = null;



  getpmsyearlist() {
    this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
      // this.pmsYears = formatYearRanges(data?.data?.yearRanges);
      this.pmsYears = formatYearRanges(data?.data?.yearRanges)
        ?.filter((item: any) => {
          const year = parseInt(item.year?.split('-')[0], 10);
          return year <= new Date().getFullYear();
        }) || [];

      const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);

      const yearValue = `${fiscalStartYear}-${fiscalEndYear}`;

      this.setSelectedYear(yearValue);

      this.getAllEmployeeListing();

    });
  }
  setSelectedYear(yearValue: string): void {
    const selectedYearObj = this.pmsYears.find((ele: any) => ele.year === yearValue);
    if (selectedYearObj) {
      this.selectedYearForCompetency = selectedYearObj?.year;

      let test = selectedYearObj?.year.split('-');
      this.fromYear = test[0];
      this.toYear = test[1];
    }
  }







  searchTaskString: string = '';

  onSearchTask(searchString: string) {

    console.log("onSearchTask --" + this.loggedInUserRole);

    if (this.loggedInUserRole == 'Employee') {


      let seacrhData = this.tableDataDetails;
      if (searchString == '') {

        this.getAllEmployeeListing();
        this.tableDataDetails = [...this.tableDataDetails]; // Update tableDataDetails with full data
      } else {
        // Filter rows based on the search string matching any of the fields
        this.filteredData = seacrhData.filter((row: any) =>
          (row.reimbursementType && row.reimbursementType.toLowerCase().includes(searchString.toLowerCase())) ||
          (row.date && row.date.toLowerCase().includes(searchString.toLowerCase())) ||
          (row.reimbursementLimit && row.reimbursementLimit.toString().includes(searchString)) ||
          (row.actualAmount && row.actualAmount.toString().includes(searchString))
          ||
          (row.assignedAmount && row.assignedAmount.toString().includes(searchString))
          ||
          (row.status && row.status.toString().includes(searchString))
          ||
          (row.approvedStatus && row.approvedStatus.toString().includes(searchString))
        );

        this.tableDataDetails = [...this.filteredData];

      }
    } else if (this.loggedInUserRole == 'Manager' || this.loggedInHODManager == 'HODManager') {

      if (this.selectedTypeTabName == 'Employee') {
        let seacrhDataForTeam = this.currentTableDataDetailsForEmployee;
        if (searchString == '') {

          this.getAllEmployeeListing();
          this.tableDataDetails = [...this.currentTableDataDetailsForEmployee]; // Update tableDataDetails with full data
        } else {
          // Filter rows based on the search string matching any of the fields


          this.filteredData = seacrhDataForTeam.filter((row: any) =>

            (row.employeeName && row.employeeName.toLowerCase().includes(searchString.toLowerCase())) ||
            (row.reimbursementType && row.reimbursementType.toLowerCase().includes(searchString.toLowerCase())) ||
            (row.date && row.date.toLowerCase().includes(searchString.toLowerCase())) ||
            (row.reimbursementLimit && row.reimbursementLimit.toString().includes(searchString)) ||

            (row.actualAmount && row.actualAmount.toString().includes(searchString))
            ||
            (row.assignedAmount && row.assignedAmount.toString().includes(searchString))
            ||
            (row.status && row.status.toString().includes(searchString))
            ||
            (row.approvedStatus && row.approvedStatus.toString().includes(searchString))
          );

          this.tableDataDetails = [...this.filteredData];

        }

      } else if (this.selectedTypeTabName == 'Finance') {

        let seacrhDataForTeam = this.currentallTeamMemberReimbursementApprove;
        if (searchString == '') {

          this.getAllEmployeeListing();
          this.allTeamMemberReimbursementApprove = [...this.currentallTeamMemberReimbursementApprove]; // Update tableDataDetails with full data
        } else {
          // Filter rows based on the search string matching any of the fields
          this.filteredData = seacrhDataForTeam.filter((row: any) =>
            (row.employeeName && row.employeeName.toLowerCase().includes(searchString.toLowerCase())) ||
            (row.reimbursementType && row.reimbursementType.toLowerCase().includes(searchString.toLowerCase())) ||
            (row.date && row.date.toLowerCase().includes(searchString.toLowerCase())) ||
            (row.reimbursementLimit && row.reimbursementLimit.toString().includes(searchString)) ||
            (row.actualAmount && row.actualAmount.toString().includes(searchString))
            ||
            (row.assignedAmount && row.assignedAmount.toString().includes(searchString))
            ||
            (row.status && row.status.toString().includes(searchString))
            ||
            (row.approvedStatus && row.approvedStatus.toString().includes(searchString))
          );

          this.allTeamMemberReimbursementApprove = [...this.filteredData];

        }

      } else {

        let seacrhDataForTeam = this.allTeamReimbursement;
        if (searchString == '') {

          this.getAllEmployeeListing();
          this.allTeamReimbursement = [...this.allTeamReimbursement]; // Update tableDataDetails with full data
        } else {
          // Filter rows based on the search string matching any of the fields
          this.filteredData = seacrhDataForTeam.filter((row: any) =>
            (row.employeeName && row.employeeName.toLowerCase().includes(searchString.toLowerCase())) ||
            (row.reimbursementType && row.reimbursementType.toLowerCase().includes(searchString.toLowerCase())) ||
            (row.date && row.date.toLowerCase().includes(searchString.toLowerCase())) ||
            (row.reimbursementLimit && row.reimbursementLimit.toString().includes(searchString)) ||
            (row.actualAmount && row.actualAmount.toString().includes(searchString))
            ||
            (row.assignedAmount && row.assignedAmount.toString().includes(searchString))
            ||
            (row.status && row.status.toString().includes(searchString))
            ||
            (row.approvedStatus && row.approvedStatus.toString().includes(searchString))
          );

          this.allTeamReimbursement = [...this.filteredData];

        }
      }


    } else if (this.loggedInUserRole == 'HR Admin') {
      let seacrhDataForTeam = this.allTeamMemberReimbursementApprove;
      if (searchString == '') {

        this.getAllEmployeeListing();
        this.allTeamMemberReimbursementApprove = [...this.allTeamMemberReimbursementApprove]; // Update tableDataDetails with full data
      } else {
        // Filter rows based on the search string matching any of the fields
        console.log("HR Admin search data is ...", this.filteredData);
        this.filteredData = seacrhDataForTeam.filter((row: any) =>


          (row.employeeName && row.employeeName.toLowerCase().includes(searchString.toLowerCase())) ||
          (row.reimbursementType && row.reimbursementType.toLowerCase().includes(searchString.toLowerCase())) ||
          (row.band && row.band.toLowerCase().includes(searchString.toLowerCase())) ||
          (row.location && row.location.toLowerCase().includes(searchString.toLowerCase())) ||
          (row.date && row.date.toLowerCase().includes(searchString.toLowerCase())) ||
          (row.reimbursementLimit && row.reimbursementLimit.toString().includes(searchString)) ||
          (row.actualAmount && row.actualAmount.toString().includes(searchString))
          ||
          (row.assignedAmount && row.assignedAmount.toString().includes(searchString))
          ||
          (row.status && row.status.toString().includes(searchString))
          ||
          (row.approvedStatus && row.approvedStatus.toLowerCase().includes(searchString))
        );

        this.allTeamMemberReimbursementApprove = [...this.filteredData];

      }
    }



  }



} 
